(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('laws-pertaining-to-women', {
            parent: 'app',
            url: '/laws-pertaining-to-women',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/laws-pertaining-to-women/laws-pertaining-to-women.html',
                    controller: 'LawsPertainingToWomenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('laws-pertaining-to-women');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
